<div class="background-round">
    <!-- Modal Header -->
    <div class="modal-header modal-head">
        <div class="modal-titles">{{ 'pages.xml.title' | translate }}</div>
    </div>

    <!-- Modal body -->
    <div class="modal-body">
        <form [formGroup]="formBuilder">
            <div class="row">
                <div class="col">
                    <div class="m-3">
                        <label class="form-label label-fw">
                            {{ 'pages.xml.file-name' | translate }}
                        </label>
                        <input id="filename" class="modal-input" type="text" formControlName="filename" disabled>
                    </div>
                </div>
            </div>

            <!--drag&drop area-->
            <div class="row">
                <div class="col">
                    <div class="drag-area d-flex m-3" appDnd (fileDropped)="onFileDropped($event)">
                        <div class="icona justify-content-center">
                            <i class="fal fa-upload"></i>
                        </div>
                        <header>Drag&Drop here</header>
                        <span>or</span>
                        <button type="button" class="browse mb-3" (click)="fileUpload.click()"><i
                                class="fas fa-folder-open"></i> Browse
                            file
                        </button>
                        <input #fileUpload id="fileUpload" hidden type="file" (change)="onFileChange($event)"
                               accept=".xml">

                    </div>
                </div>
            </div>
        </form>

        <!-- Modal footer -->
        <div class="modal-foot">
            <div class="row my-3 text-center">

                <button type="button" [disabled]="form.status === 'INVALID'" class="btn btn-fw text me-3"
                        (click)="save()">Salva modifiche
                </button>
                <button type="button" class="btn btn-outline-fw text" (click)="cancel()">Annulla</button>

            </div>
        </div>
    </div>

</div>

<div class="background-round" *ngIf="xmlRed">
    <div class="modal-header modal-head">
        <div class="modal-titles">Download tutti gli store Fastweb da condividere con Red </div>
    </div>
    <div class="modal-body d-flex justify-content-center">
        <button type="button"  class="btn btn-fw text my-4" (click)="exportXlsx()">Download Excel</button>
    </div>
</div>


    